import { icons } from '../../assets/assets';
import GameMaterialItem from './GameMaterialItem';
import {connect} from "react-redux";

class VideoGameMaterial extends GameMaterialItem {
  constructor(props) {
    super(props);
    this.state.icons = [icons.play2];
    this.handleClick = () => {
      if (!props.project.offline && props.item.alternateUrl && props.item.alternateUrl.match(/drive.google.com/g)) {
        window.open(`/portal/drive?url=${encodeURIComponent(props.item.alternateUrl)}`, '_blank');
        return;
      }
      if ((props.item.type === 'video' || props.item.type === 'file') && (props.project.offline || props.item.alternateId === null)) {
        window.open(`/portal/video/${props.item.MaterialId}?windowTitle=${encodeURIComponent(props.item.windowTitle)}&faviconUrl=${encodeURIComponent(props.item.faviconUrl)}&backgroundUrl=${encodeURIComponent((props.item.Background ? props.item.Background.url : "null"))}&publicMaterialId=${props.item.isPublic ? props.item.id : null}`, '_blank');
      } else {
        window.open(`/portal/vimeo/${props.item.vimeoId || props.item.alternateId}?windowTitle=${encodeURIComponent(props.item.windowTitle)}&faviconUrl=${encodeURIComponent(props.item.faviconUrl)}&backgroundUrl=${encodeURIComponent((props.item.Background ? props.item.Background.url : "null"))}&publicMaterialId=${props.item.isPublic ? props.item.id : null}`, '_blank');
      }
    }
  }
}
export default connect(state => ({
  project: state.project
}))(VideoGameMaterial);




// WEBPACK FOOTER //
// ./src/components/elements/VideoGameMaterial.js